import { z } from "zod";

// Schemas

export const DateTypeSchema = z.union([
  z.date(),
  z.string().transform((str) => new Date(str)),
]) as z.ZodType<Date>;

export const SourceTypeSchema = z.enum(["client", "server"]);

export const StatusTypeSchema = z.enum(["draft", "private", "public"]);

export const RoleTypeSchema = z.enum([
  "none",
  "admin",
  "edit",
  "view",
  "submit",
]);

export const TemplateTypeSchema = z.object({
  template: z.boolean().optional(),
  templateId: z.string().optional(),
});
